import React from 'react'
import { useOutletContext } from 'react-router-dom'
import PropTypes from 'prop-types'

import { ReactComponent as CallIcon } from '../../assets/images/common/icons/call-icon.svg'
import { ReactComponent as MailIcon } from '../../assets/images/common/icons/mail-icon.svg'

import Loader from '../common/loader/Loader'
import classes from './FamilyContactPage.module.scss'

import StudentWithAvatar from '../students/StudentWithAvatar'
import { calculateAge, genderLabel } from '../../utility/userHelper'
import { formatPhoneForLinks } from '../../utility/phoneHelper'

const FamilyAdminCard = ({ familyAdmin }) => (
  <div className={classes.familyAdminCard}>
    <h6 className='font-weight-bold'>Contact Family Admin</h6>
    <div className={classes.profile}>
      <StudentWithAvatar student={familyAdmin} />
      <div className={classes.info}>
        <div className={classes.name}>
          <span>{familyAdmin.firstName} {familyAdmin.lastName}</span>
          <span className={classes.familyAdminLabel}>Family Admin</span>
        </div>
        <span>
          {familyAdmin.birthdate !== null && `Age ${calculateAge(familyAdmin.birthdate)} / `}
          {genderLabel[familyAdmin.gender].at(0)}
        </span>
      </div>
    </div>
    <div className={classes.contactButtons}>
      {familyAdmin.phonePrefix && familyAdmin.phone && (
        <span>
          {familyAdmin.phonePrefix} {familyAdmin.phone || ''}
          <a href={familyAdmin.phone ? `tel:${formatPhoneForLinks(familyAdmin.phonePrefix, familyAdmin.phone)}` : '#'}>
            <CallIcon className={classes.contactIcon} />
          </a>
        </span>
      )}
      <span>
        {familyAdmin.email || '-'}
        <a href={familyAdmin.email ? `mailto:${familyAdmin.email}` : '#'}>
          <MailIcon className={classes.contactIcon} />
        </a>
      </span>
    </div>
  </div>
)

FamilyAdminCard.propTypes = {
  familyAdmin: PropTypes.object.isRequired,
}

const FamilyContactPage = () => {
  const { family } = useOutletContext()

  if (!family?.familyAdmins) {
    return (
      <div className='h-100 d-flex align-items-center justify-content-center'>
        <Loader>Loading Family Enrollments</Loader>
      </div>
    )
  }

  return (
    <main className={classes.wrapper}>
      <main>
        {family.familyAdmins.map(familyAdmin => <FamilyAdminCard key={familyAdmin.id} familyAdmin={familyAdmin} />)}
      </main>
    </main>
  )
}

export default FamilyContactPage
